export default {
    title: 'Organisation',
    subtitle: 'Détails et informations de l\'organisation.',
    logo: {
        title: 'Logo',
        helper: 'Le logo de votre organisation, affiché sur la plateforme.',
        hint: 'Image carrée, 256×256px minimum recommandé.',
    },
    general: {
        title: 'Général',
        name: 'Nom',
        slug: 'Slug',
        slugHint: 'Identifiant URL de votre organisation.',
    },
    language: {
        title: 'Langue',
        subtitle: 'La langue sélectionnée sera utilisée pour tous les emails envoyés au nom de votre organisation.',
        label: 'Langue',
    },
    branding: {
        title: 'Apparence',
        primaryColor: 'Couleur principale',
        primaryColorHint: 'Couleur d\'accent utilisée sur la plateforme.',
    },
    contact: {
        title: 'Contact',
        email: 'Email',
        phone: 'Téléphone',
        website: 'Site web',
    },
    legal: {
        title: 'Informations légales',
        // L'identité facturée a quitté cette page le 2026-09-20 : elle est tenue par le service de
        // facturation et s'édite dans Facturation. Ne restent ici que les deux mentions
        // descriptives de l'organisation, qui sont les siennes.
        legalName: 'Raison sociale',
        taxId: 'Numéro fiscal',
    },
    system: {
        title: 'Système',
        createdAt: 'Créé le',
    },
}
